/* eslint-disable @typescript-eslint/prefer-as-const */
"use client";
import React, { useEffect } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { useDispatch } from "react-redux";
import { SiteServices } from "@/interfaces/ISiteServices";
import { getSiteService } from "@/services/backOffice";
import { hydrateApp, setSiteServices } from "@/slices/appSlice";

export const AppProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    const userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
      windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
      iosPlatforms = ["iPhone", "iPad", "iPod"];

    let os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = "Mac OS" as "Mac OS";
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = "iOS" as "iOS";
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = "Windows" as "Windows";
    } else if (/Android/.test(userAgent)) {
      os = "Android" as "Android";
    } else if (!os && /Linux/.test(platform)) {
      os = "Linux" as "Linux";
    }
    let siteservices: SiteServices[] = [];
    (async () => {
      const { data } = await getSiteService();
      siteservices = data;
      dispatch(setSiteServices(data));
    })();

    dispatch(
      hydrateApp({
        userAgent: os,
        siteServices: siteservices,
        darkMode: false,
        stripePayment: false,
        superPayment: false,
        superPaymentTest: false,
      }),
    );
  });

  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterLuxon}>{children}</LocalizationProvider>
    </div>
  );
};
